import { userLanguage, ValidLanguages } from '$translations/index';
import {
  CompanyBuilder,
  GetClientsByCompanyIdOutput,
  GetClientsByCompanyIdInput,
} from '../companies.types';
import { errorHandler } from '../../../utils';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';

export const getClientsByCompanyId = (builder: CompanyBuilder) =>
  builder.query<GetClientsByCompanyIdOutput, GetClientsByCompanyIdInput>({
    query: ({ companyId }) => ({
      url: `/companies/${companyId}/employers`,
      method: 'GET',
    }),
    // Adding or removing a member invalidates this, so the company page refetches its members.
    providesTags: (_result, _error, { companyId }) => [
      { type: 'Company', id: `members-${companyId}` },
    ],
    transformErrorResponse: (error) => {
      errorHandler(
        '[getClientsByCompanyId]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.PositionSetError
          : ErrorMessageEn.PositionSetError,
        error,
        true
      );
      return error.data;
    },
  });
